<template>
  <div class="msg-box">
    <div class="box-con-msg">
      <div class="msg-box">
        <textarea
          class="msg-box-text"
          placeholder="回复：李强"
          maxlength="500"
          ref="msgBoxText"
          v-model="text"
        ></textarea>
        <em>{{ text.length }}/500</em>
      </div>
      <div class="btn-box">
        <div class="emoji">
          <em @click="handleEmoji">
            <img src="@/assets/img/user/emoji.png" class="emoji-img" />
            <span>添加表情</span>
          </em>
          <div class="emoji-box" v-if="emojiFlag">
            <div class="title">鹿小兔来了~</div>
            <span class="emoji-close" @click="handleEmoji">✕</span>
            <div class="img-box">
              <img
                src="@/assets/img/test/emoji.png"
                class="img-box-img"
                v-for="item in 10"
                :key="item"
              />
            </div>
            <div class="pages">
              <img src="../../../assets/img/test/left.png" alt="" />
              <img src="../../../assets/img/test/right.png" alt="" />
            </div>
          </div>
        </div>
        <div class="btn-send" @click="handleCommonetPost">评论</div>
      </div>
    </div>
    <Comments :msgBoardList="msgBoardList" />
  </div>
</template>

<script>
import Comments from "@/components/Comments";
import {
  artCourseComment,
  artExpression,
  artCourseCommentPost,
} from "@/api/CourseCenter";
export default {
  name: "MsgBox",
  components: {
    Comments,
  },
  data() {
    return {
      textLen: 0,
      text: "",
      emojiFlag: false,
      msgBoardList: [],
    };
  },
  mounted() {
    var textarea = this.$refs.msgBoxText;
    textarea.addEventListener("input", (e) => {
      textarea.style.height = "56px";
      textarea.style.height = e.target.scrollHeight + "px";
    });
    this.artCourseCommentFunc();
  },
  methods: {
    handleCommonetPost() {
      let params = {
        chapterId: 0,
        content: this.text,
        courseId: 0,
        pid: 0,
        replyUserId: 0,
        subsectionId: 0,
      };
      artCourseCommentPost(params)
        .then((res) => {
          console.log("artCourseCommentPost", res);
          this.$message.success("评论成功！");
          this.text = "";
          this.artCourseCommentFunc();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artCourseCommentFunc() {
      let params = {
        limit: 100,
        page: 1,
        subsectionId: "",
      };
      artCourseComment(params)
        .then((res) => {
          console.log("res====>", res);
          this.msgBoardList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEmoji() {
      this.emojiFlag = !this.emojiFlag;
      artExpression()
        .then((res) => {
          console.log("artExpression ", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.msg-box {
  .box-con-msg {
    overflow: hidden;
    .msg-box {
      position: relative;
      .msg-box-text {
        box-sizing: border-box;
        width: 100%;
        height: 96px;
        min-height: 96px;
        padding: 17px 84px 17px 16px;
        color: #d7d7d7;
        resize: none;
        background-color: rgba(255, 255, 255, 0.2);
        border: none;
      }
      em {
        font-size: 15px;
        color: #aaa;
        position: absolute;
        bottom: 20px;
        right: 16px;
      }
    }
    .btn-box {
      padding-top: 26px;
      .emoji {
        position: relative;
        > em {
          cursor: pointer;
        }
        .emoji-img {
          width: 21px;
          height: 21px;
          opacity: 0.6;
          filter: invert(1);
        }
        span {
          margin-left: 4px;
          line-height: 19px;
          font-size: 16px;
          color: #d7d7d7;
          vertical-align: bottom;
        }
        .emoji-box {
          width: 497px;
          height: 468px;
          background: #555;
          position: absolute;
          left: 0;
          top: 32px;
          padding: 0 0 10px 10px;
          .title {
            height: 56px;
            line-height: 50px;
            font-size: 15px;
            color: #fff;
            text-align: center;
          }
          .emoji-close {
            width: 20px;
            height: 20px;
            color: #fff;
            position: absolute;
            right: 16px;
            top: 28px;
            font-size: 20px;
            cursor: pointer;
          }
          .img-box {
            display: flex;
            justify-content: left;
            flex-wrap: wrap;
            .img-box-img {
              width: 112px;
              height: 108px;
              cursor: pointer;
              margin: 10px 10px 0 0;
            }
            .img-box-img:nth-of-type(4n) {
              margin-right: 0;
            }
          }
          .pages {
            padding-top: 20px;
            text-align: center;
            img {
              width: 14px;
              height: 21px;
              margin-right: 44px;
            }
          }
        }
      }
      .btn-send {
        margin-top: -2px;
        float: right;
        width: 135px;
        height: 45px;
        line-height: 45px;
        background-color: #da514e;
        color: #fff;
        font-size: 15px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
